export const notificationsMessages = [
  'New request for account verification',
  'New request for account statistics approval',
  'New request for content verification',
  'New request for offer review',
  'New request for money withdrawal',
];
